import type { FieldId } from '~/features/fields/types/FieldId';

import { FieldModel } from '~/features/x-ray/fields/types';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModelVersion } from '../../types/sylvanus/model';
import { mapModelVersionToFieldModel } from './transformers';

export const DEPRECATED_getPromptModelVersion = async ({
  modelId,
  version,
  fieldId, // TODO: remove this dependency (sylvanus doesn't need it and neither should our transform)
  highlightMethod,
}: {
  modelId: Uuid;
  version: number;
  fieldId?: FieldId;
  highlightMethod: string;
}): Promise<FieldModel> => {
  const response: PromptModelVersion = await sylvanus.get(
    `/model/${modelId}/version/${version}`,
  );

  return mapModelVersionToFieldModel({
    modelId,
    version: response,
    fieldId,
    highlightMethod,
    optimizeState:
      response.optimize?.version_number === response.version_number
        ? response.optimize?.state
        : null,
    publishStatus: null,
  });
};
